import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Typography, Paper } from '@material-ui/core'
import {SystemIcon} from '@workday/canvas-kit-react/icon';
import {clipboardIcon} from '@workday/canvas-system-icons-web';

import PageTitle from '../global/PageTitle/PageTitle'
import { searchItems } from '../Navbar/components/searchbar/SearchbarData'
import './SearchResults.css'

// Pressing Enter in the header search with no result highlighted lands here (QA issue 1).
const SearchResults = () => {
    const { search } = useLocation()
    const query = (new URLSearchParams(search).get('q') || '').trim()
    const results = searchItems(query)

    return (
        <div>
            <PageTitle title="Search Results" back />
            <div className="search-results-main">
                <Typography variant="caption" className="search-results-summary" role="status">
                    {query
                        ? `${results.length} ${results.length === 1 ? 'result' : 'results'} for "${query}"`
                        : 'Type in the search bar and press Enter to search.'}
                </Typography>
                <Paper className="search-results-list">
                    {results.length === 0 && query && (
                        <div className="search-results-empty">No results for "{query}"</div>
                    )}
                    {results.map(result => (
                        <Link key={result.path} to={result.path} className="search-results-item">
                            <SystemIcon size={"3.5vh"} icon={clipboardIcon} />
                            <div className="search-results-text">
                                <p className="search-results-title">{result.title}</p>
                                <p className="search-results-type">{result.type}</p>
                            </div>
                        </Link>
                    ))}
                </Paper>
            </div>
        </div>
    )
}

export default SearchResults
